// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "service_resource_eligibility".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "service_resource_eligibility" table (1:1 with a DB row, on the wire). */
export const serviceResourceEligibilityAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    serviceId: z.string(),
    resourceId: z.string(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=serviceResourceEligibility.js.map